module.exports = __webpack_public_path__ + "static/media/twitter2.5841538f.svg";